import { useEffect, useRef, useState } from "react";
import { Control, Input, Level, Props, Wrapper } from "./VolumeSlider.Parts";
import { SpeakerIconButton } from "./speaker-icon-button/SpeakerIconButton";

export const VolumeSlider = ({ volume = 50, onChange }: Props) => {
  const previousLevel = useRef(volume > 0 ? volume : 50);
  const [localVolumeLevel, setLocalVolumeLevel] = useState(volume);

  useEffect(() => {
    setLocalVolumeLevel(volume);
  }, [volume]);

  const handleMute = () => {
    if (localVolumeLevel > 0) {
      previousLevel.current = localVolumeLevel;
      setLocalVolumeLevel(0);
      onChange(0);
      return;
    }

    setLocalVolumeLevel(previousLevel.current);
    onChange(previousLevel.current);
  };

  const handleDrag = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = Number(e.currentTarget.value);
    setLocalVolumeLevel(value);
    if (value > 0) previousLevel.current = value;

    onChange(value);
  };

  return (
    <Wrapper>
      <Control>
        <Input
          min="0"
          max="100"
          type="range"
          value={localVolumeLevel}
          onChange={handleDrag}
        />
        <Level $volume={localVolumeLevel} />
      </Control>
      <SpeakerIconButton $muted={localVolumeLevel === 0} onClick={handleMute} />
    </Wrapper>
  );
};
